import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bar",
  "use": "icon-bar-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bar\"><path d=\"M556.8 128l128 0 0 768-128 0 0-768Z\" p-id=\"18442\" /><path d=\"M768 512l128 0 0 384-128 0 0-384Z\" p-id=\"18443\" /><path d=\"M352 384l128 0 0 512-128 0 0-512Z\" p-id=\"18444\" /><path d=\"M128 640l128 0 0 256-128 0 0-256Z\" p-id=\"18445\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol